import React from 'react';
import { StyleSheet, View } from 'react-native';
import Button from 'shared/components/vxl/Button/Button';
import BodySmText from 'shared/components/vxl/typography/primary/body/BodySmText';
import BodyXSText from 'shared/components/vxl/typography/primary/body/BodyXSText';
import TitleSmText from 'shared/components/vxl/typography/primary/title/TitleSmText';
import theme from 'shared/styles/theme';

export interface DebtSaleAccountSummaryCardButton {
  label: string;
  onPress: () => void;
}

export interface DebtSaleAccountSummaryCardProps {
  title: string;
  subtitle: string;
  body: string;
  button: DebtSaleAccountSummaryCardButton;
}

const DebtSaleAccountSummaryCard = ({
  title,
  subtitle,
  body,
  button,
}: DebtSaleAccountSummaryCardProps) => {
  return (
    <View style={styles.container} accessible={false}>
      <View style={styles.titleGroup}>
        <TitleSmText>{title}</TitleSmText>
        <BodyXSText style={styles.subtitle}>{subtitle}</BodyXSText>
      </View>
      <BodySmText style={styles.body}>{body}</BodySmText>
      <Button
        label={button.label}
        onPress={button.onPress}
        type="SECONDARY"
        width="FULL"
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    borderColor: theme.color.border.primary,
    borderRadius: theme.spacing.xs,
    borderWidth: 1,
    gap: theme.spacing.m,
    padding: theme.spacing.m,
  },
  titleGroup: {
    gap: theme.spacing.xs,
  },
  subtitle: {
    color: theme.color.text.secondary,
  },
  body: {
    color: theme.color.text.primary,
  },
});

export default DebtSaleAccountSummaryCard;
